import React, { useEffect, useState } from 'react';
import heroBanner from '../assets/images/hero-banner.png';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import blogdetails1 from '../assets/images/blog-detail-1.jpg';
import blogdetails2 from '../assets/images/blog-detail-2.jpg';
import blogdetails3 from '../assets/images/blog-detail-3.jpg';
import blog1 from '../assets/images/blog-1.png';
import arrowup from '../assets/images/arrow-up-right.svg';
import profile1 from '../assets/images/profile1.png';
import blog2 from '../assets/images/blog-2.png';
import blogavtr2 from '../assets/images/blog-avtar2.png';
import blog3 from '../assets/images/blog-3.png';
import blogavtr3 from '../assets/images/blog-3.png';
import btnround from '../assets/images/btn-round.svg';
import connectionbanner from '../assets/images/connection-banner.png';
import { Link } from 'react-router-dom';
import '../styles/bubbles.css';
import '../styles/style.css';


function BlogDetails() {
 
  return (
  
      <>
      {/* <!-- preloader end  -->
      <!-- Mouse Cursor Start -->   */}
      <div className="mouse-cursor cursor-outer"></div>
      <div className="mouse-cursor cursor-inner"></div>
      <header className="top-header inner-banner" style={{background: `url(${heroBanner}) no-repeat top center`}}>
         <div id="stars"></div>
         <div id="stars2"></div>
         <div id="stars3"></div>
        <Navbar/>
         <section className="banner-caption flex-center">
            <div className="caption-header text-white">
               <div className="container text-center">
                  <h1 className="caption-title"> The Future of Enterprise Technology Integration </h1>
               </div>
            </div>
         </section>
      </header>
      {/* <!-- /Blog Details Section --> */}

      <section className="blog-details py-5">
         <div className="container">
            <div className="row pt-5 d-flex justify-content-center">
               <div className="col-lg-12">
                  {/* <!-- Blog Details Section --> */}
                  <article className="article">

                   


                     <div className="thumbnail-block post-img mb-3">
                        <div className="card-image">
                           <img src={blogdetails1} alt="blog-details-1" className="img-fluid"/>
                        </div>
                     </div>



                     <h2 className="title">Hyperautomation and Intelligent Process Automation (IPA)</h2>
                     <div className="meta-top">
                        <ul>
                           <li className="d-flex align-items-center"><i className="uil-user"></i> <Link to="#">John Doe</Link></li>
                           <li className="d-flex align-items-center"><i className="uil-calender"></i> <Link to="#"><time datetime="2020-01-01">Jan 1, 2024</time></Link></li>
                        </ul>
                     </div>
                     {/* <!-- End meta top --> */}
                     <div className="content">
                        <p>
                          Automation has long been a central theme in enterprise integration, but the future lies in hyperautomation—the combination of AI, machine learning (ML), robotic process automation (RPA), and advanced analytics to automate complex business processes end-to-end. Hyperautomation doesn’t just replace manual tasks; it enables processes to evolve, optimize themselves, and adapt to changing business needs without human intervention. 
                        </p>

                        <p>Intelligent Process Automation (IPA) takes automation a step further, leveraging AI to integrate workflows, orchestrate systems, and derive insights from data streams in real time. By using IPA, businesses can create a connected ecosystem where ERP systems, CRM platforms, and other tools function in harmony, reducing bottlenecks, improving decision-making, and enhancing customer experiences.</p>
                        <blockquote>
                           <p>
                            The future of enterprise technology integration lies in intelligent automation, real-time data processing, and modular architectures that empower organizations to operate with agility and innovation. 
                           </p>
                        </blockquote>

                        <div className="row">
                          <div className="col-lg-6">
                            <div className="thumbnail-block post-img mb-3">
                              <div className="card-image">
                                 <img src={blogdetails2} alt="blog-detail-2.jpg" className="img-fluid"/>
                              </div>
                           </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="thumbnail-block post-img mb-3">
                              <div className="card-image">
                                 <img src={blogdetails3} alt="blog-detail-3.jpg" className="img-fluid"/>
                              </div>
                           </div>
                          </div>
                        </div>



                        <h2 className="title">The Shift to Cloud-Native Integration</h2>
                        <p>
                          Cloud computing is not a new concept, but its role in enterprise integration continues to evolve. The future is cloud-native—where applications and systems are designed specifically to leverage the full power of the cloud. Microservices architectures and containers like Kubernetes are becoming fundamental components of cloud-native integration strategies. These technologies make it easier for enterprises to break down monolithic systems into smaller, loosely coupled services that are easier to integrate, manage, and scale.
                        </p>
                     </div>
                     {/* <!-- End post content --> */}
                     <div className="meta-bottom">
                        <i className="uil-bag"></i>
                        <ul className="cats">
                           <li><Link to="#">Business</Link></li>
                        </ul>
                        <i className="uil-tag"></i>
                        <ul className="tags">
                           <li><Link to="#">Creative</Link></li>
                           <li><Link to="#">Tips</Link></li>
                           <li><Link to="#">Marketing</Link></li>
                        </ul>
                     </div>
                     {/* <!-- End meta bottom --> */}
                  </article>
               </div>
            </div>
         </div>
      </section>
      {/* <!-- /Blog Details Section --> */}

      <section className="blog py-5 related-blog">
         <div className="container">
            <div className="row">
               <div className="col-8">
                  <div className="title">
                     <h1 className="section-title mb-4">Related Blogs</h1>
                  </div>
               </div>
               <div className="col-4 text-md-end">
                  <div className="custom-arrow">
                     <button className="button-slider slide-arrow prev-arrow"><i className="uil-arrow-left"></i></button>
                     <button className="button-slider slide-arrow next-arrow"><i className="uil-arrow-right"></i></button>
                  </div>
               </div>
            </div>
            <div className="blog-carousel">
               <div className="blog-container shadow">
                  <div className="blog-banner card-image">
                     <img src={blog1} alt="Blog banner" className="img-fluid blog-img" />
                  </div>
                  <div className="blog-content">
                     <div className="blog-item-name">Design</div>
                     <div className="blog-title py-3">
                        <h1> The Future of Enterprise Technology Integration </h1>
                     </div>
                     <div className="blog-body-content mb-3">
                        <p className="mb-0"> Explore how emerging technologies like AI and machine learning are shaping the future of enterprise technology. Discover how businesses can stay competitive by adopting these cutting-edge solutions. </p>
                     </div>
                     <Link to="#" className="blog-link">Read More <span>
                     <img src={arrowup} alt="arrow-up" />
                     </span>
                     </Link>
                  </div>
                  <div className="blog-footer d-flex pt-5 pb-2">
                     <div className="profile me-3">
                        <img src={profile1} alt="Blog profile" className="img-fluid" />
                     </div>
                     <div className="profile-desc">
                        <p>Olivia Rhye</p>
                        <span className="blog-date">20 Jan 2022</span>
                     </div>
                  </div>
               </div>
               <div className="blog-container shadow">
                  <div className="blog-banner card-image">
                     <img src={blog2} alt="Blog banner" className="img-fluid blog-img" />
                  </div>
                  <div className="blog-content">
                     <div className="blog-item-name">Product</div>
                     <div className="blog-title py-3">
                        <h1> Case Study: Successful <br />System Integration for a Global Retailer </h1>
                     </div>
                     <div className="blog-body-content mb-3">
                        <p className="mb-0"> Linear helps streamline software projects, sprints, tasks, and bug tracking. Here’s how to get started. </p>
                     </div>
                     <Link to="#" className="blog-link">Read More <span>
                     <img src={arrowup} alt="arrow-up" />
                     </span>
                     </Link>
                  </div>
                  <div className="blog-footer d-flex pt-5 pb-2">
                     <div className="profile me-3">
                        <img src={blogavtr2} alt="Blog profile" className="img-fluid" />
                     </div>
                     <div className="profile-desc">
                        <p>Phoenix Baker</p>
                        <span className="blog-date">19 Jan 2022</span>
                     </div>
                  </div>
               </div>
               <div className="blog-container shadow">
                  <div className="blog-banner card-image">
                     <img src={blog3} alt="Blog banner" className="img-fluid blog-img" />
                  </div>
                  <div className="blog-content">
                     <div className="blog-item-name"> Software Engineering </div>
                     <div className="blog-title py-3">
                        <h1> Top 5 Challenges in Data Integration and How to Overcome Them </h1>
                     </div>
                     <div className="blog-body-content mb-3">
                        <p className="mb-0"> Data integration can be complex, but with the right strategies, it’s possible to overcome common challenges. Read our guide on navigating the pitfalls and ensuring seamless data unification. </p>
                     </div>
                     <Link to="#" className="blog-link">Read More <span>
                     <img src={arrowup} alt="arrow-up" />
                     </span>
                     </Link>
                  </div>
                  <div className="blog-footer d-flex pt-5 pb-2">
                     <div className="profile me-3">
                        <img src={blogavtr3} alt="Blog profile" className="img-fluid" />
                     </div>
                     <div className="profile-desc">
                        <p>Lana Steiner</p>
                        <span className="blog-date">18 Jan 2022</span>
                     </div>
                  </div>
               </div>
               <div className="blog-container shadow">
                  <div className="blog-banner card-image">
                     <img src={blog1} alt="Blog banner" className="img-fluid blog-img" />
                  </div>
                  <div className="blog-content">
                     <div className="blog-item-name">Design</div>
                     <div className="blog-title py-3">
                        <h1> The Future of Enterprise Technology Integration </h1>
                     </div>
                     <div className="blog-body-content mb-3">
                        <p className="mb-0"> Explore how emerging technologies like AI and machine learning are shaping the future of enterprise technology. Discover how businesses can stay competitive by adopting these cutting-edge solutions. </p>
                     </div>
                     <Link to="#" className="blog-link">Read More <span>
                     <img src={arrowup} alt="arrow-up" />
                     </span>
                     </Link>
                  </div>
                  <div className="blog-footer d-flex pt-5 pb-2">
                     <div className="profile me-3">
                        <img src={profile1} alt="Blog profile" className="img-fluid" />
                     </div>
                     <div className="profile-desc">
                        <p>Olivia Rhye</p>
                        <span className="blog-date">20 Jan 2022</span>
                     </div>
                  </div>
               </div>
               <div className="blog-container shadow">
                  <div className="blog-banner card-image">
                     <img src={blog2} alt="Blog banner" className="img-fluid blog-img" />
                  </div>
                  <div className="blog-content">
                     <div className="blog-item-name">Product</div>
                     <div className="blog-title py-3">
                        <h1> Case Study: Successful <br />System Integration for a Global Retailer </h1>
                     </div>
                     <div className="blog-body-content mb-3">
                        <p className="mb-0"> Linear helps streamline software projects, sprints, tasks, and bug tracking. Here’s how to get started. </p>
                     </div>
                     <Link to="#" className="blog-link">Read More <span>
                     <img src={arrowup} alt="arrow-up" />
                     </span>
                     </Link>
                  </div>
                  <div className="blog-footer d-flex pt-5 pb-2">
                     <div className="profile me-3">
                        <img src={blogavtr2} alt="Blog profile" className="img-fluid" />
                     </div>
                     <div className="profile-desc">
                        <p>Phoenix Baker</p>
                        <span className="blog-date">19 Jan 2022</span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="row">
               <div className="col-12 text-center">
                  <Link to="blog" className="btn btn-theme">
                  <span className="pe-2">
                  <img src={btnround} alt="Icon" />
                  </span>View More </Link>
               </div>
            </div>
         </div>
      </section>
      {/* <!-- /Blog Carousel --> */}

      <section className="bottom-bg py-5">
         <div className="container">
            <div className="row">
               <div className="col-lg-12">
                  <div className="dark-bg-block">
                     <div className="tech-integration d-flex align-items-center">
                        <div className="col-lg-5">
                           <div className="contact-info-block text-white">
                              <h1 className="head-medium"> Let’s Build Something Great Together </h1>
                              <p className="py-4"> Got a question or a project in mind? We're here to help. Reach out today, and let's discuss how we can integrate the perfect technology solutions for your business needs. Your next step toward innovation starts here. </p>
                           </div>
                        </div>
                        <div className="col">
                           <div className="connection-banner d-flex justify-content-end">
                              <img src={connectionbanner} alt="Integration banner" className="img-fluid" />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
      {/* <!-- footer --> */}
     <Footer/>
      <div className="progress-wrap">
         <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
         </svg>
      </div>
     
      <Helmet>
      <title>Entegation Technologies | Blog</title>

      <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.5.8/slick.min.css"/>
      <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.5.8/slick-theme.min.css"/>
         
      <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.5.9/slick.min.js"></script>
      <script src="/assets/js/carousel.js"></script>
      <script src="/assets/js/script.js"></script>
      <script src="/assets/js/form.js"></script>
    </Helmet>
    </>
  

  )
}

export default BlogDetails